export default __webpack_public_path__ + "static/media/mobile_banner_motor.2d759767.jpg";